<template>
  <div class="input-autocomplete">
    <span class="input-autocomplete__title">{{ title }}</span>
    <v-autocomplete
      variant="outlined"
      :items="options"
      :model-value="modelValue"
      :item-title="optionTitleKey"
      :item-value="optionValueKey"
      no-data-text="Данных нет"
      @update:model-value="onUpdateModelValue"
    >
      <template
        v-if="$slots.selection"
        #selection="{ item }"
      >
        <slot
          name="selection"
          v-bind="{ item }"
        />
      </template>
      <template
        v-if="$slots.item"
        #item="{ props, item }"
      >
        <slot
          name="item"
          v-bind="{ props, item }"
        />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_UPDATE_MODEL_VALUE = 'update:modelValue';

/**
 * @description Компонент поля ввода с авто дополнением.
 */
export default {
  name: 'InputAutocomplete',
  props: {
    modelValue: { default: null, type: String },
    optionTitleKey: { type: String, default: 'title' },
    optionValueKey: { type: String, default: 'value' },
    options: { type: Array, default: () => [] },
    title: { type: String, default: '' }
  },
  emits: [NAME_EVENT_UPDATE_MODEL_VALUE],
  methods: {
    /**
     * @description Обработать ввод.
     * @param {any} value
     * @returns {void}
     */
    onUpdateModelValue(value) {
      this.$emit(NAME_EVENT_UPDATE_MODEL_VALUE, value);
    },
  },
};
</script>

<style lang="scss">
.input-autocomplete {
  text-align: left;
  & .v-field__input {
    padding-inline: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    min-height: 40px;
  }
  & .v-field__append-inner > .v-icon {
    opacity: 1;
  }
  & .v-field--variant-outlined.v-field--focused .v-field__outline {
    color: var(--action-color);
  }
  .mdi-menu-down::before {
    content: "";
    width: 14px;
    height: 8px;
    background: url("@/assets/img/checked-grey.svg") 50%;
    background-size: contain;
    cursor: pointer;
  }
}

</style>